import { StateCreator } from 'zustand';

import { CommonStoreType, TopSpotGameState } from '@/store/commonStore/types';

export const useTopSpotGameSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  TopSpotGameState
> = () => {
  return {
    isSuperVip: false,
    topSpotCMSData: null,
    userTSGProgressPercentByGroup: 0,
    userTSGProgressPercentByCP: 0,
    userTarget: 0,
    topSpotGameStatus: undefined,
    isTopSpotGameAvailable: false,
    isPassedSuperSpotBreakpoint: false,
  };
};
